import React from 'react';
import Image from './Image';
export const ImageFullViewWrapper = (props)=>{
    return /*#__PURE__*/ React.createElement(Image, props);
};
ImageFullViewWrapper.displayName = 'ImageFullViewWrapper';
export default ImageFullViewWrapper;
